import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Dropdown from "@/common/Dropdown";
import {updateUserCause, updateCartWhenCharityUpdates} from "@/helpers/charityHelper";
import {
    setUserCause
  } from "../../../redux/actions/generalAction";
import { empty } from "@apollo/client";
import { updateProductInCart } from "@/helpers/cartHelpers";
import { addToCart, updateCart } from "@/redux/actions/addToCartAction";

export default function CharityDropdown() {
  const cause_list = useSelector((state) => state.general.cause_list);
  const user_cause = useSelector((state) => state.general.user_cause);
  const show_charity_active_msg = useSelector((state) => state.general.show_charity_active_message);
  const default_cause = useSelector((state) => state.general.default_cause);
  const cart_list = useSelector((state) => state.click.cart_list);
  const is_userLoggedIn = useSelector((state) => state.loginUser.userLoggedIn);
  const [causeList, setCauseList] = useState([]);
  const [selectedCause, setSelectedCause] = useState([]);

  const dispatch = useDispatch();
  async function removeCartListIfError(request) {
    let res = await updateProductInCart(request);
    if(res?.error) {
      dispatch(addToCart(null))
    }
  }
  useEffect(() => {
    if(cause_list && cause_list.length>0){
        let causes = cause_list.filter((cause)=>{
          if(cause.active == 1){
              return true;
          }
        }).map((cause)=>{
            return cause.name;
        });
    
        setCauseList(causes.sort());
    }
  }, [cause_list]);

  // useEffect(() => {
  //   if(cause_list && cause_list.length>0 && user_cause){
  //       cause_list.forEach(element => {
  //           if(element.short_code == user_cause){
  //               setSelectedCause(element.name);
  //           }
  //       });
  //   }
  // }, [user_cause]);

  useEffect(() => {
    let lineItems = [];
    if (cart_list?.lineItems?.edges?.length > 0) {
      
      lineItems = cart_list.lineItems.edges.map((item) => {
        return {
          id: item.node.id,
          variantId: item.node.variant?.id,
          quantity: item.node.quantity,
          customAttributes:item.node.customAttributes
        };
      });
    }
    if(lineItems.length > 0) {
      const request = {
        lineItems,
      };

      removeCartListIfError(request)
    }
  }, [user_cause]);
  
  useEffect(() => {
    if(cause_list && cause_list.length>0 && selectedCause != user_cause){
        let request = {}
        let selCause = ""
        selCause = cause_list.filter((cause)=>{
            if(selectedCause == cause.name){
                return true;
            }
        })
        if(selCause.length > 0){
          if(is_userLoggedIn) {
            request.cause=selCause[0].short_code
            console.log('updateUserCause CharityDropdown=====')
            updateUserCause(request);
            //Update cause realted custom attribute for cart line items
            updateCartWhenCharityUpdates(selCause[0].short_code,cause_list);
            var updatedCartList = JSON.parse(sessionStorage.getItem("cart_list"));
            dispatch(updateCart(updatedCartList));
            dispatch(setUserCause(selCause[0].short_code));
          }
        }
    }
  }, [selectedCause]);

  let defaultCauseName = "";
  if (cause_list && default_cause) {
    cause_list.find((cause) => {
      if (cause.short_code == default_cause) {
        defaultCauseName = cause.name;
      }
    });
  }

  let user_cause_name = "";
  if (cause_list && user_cause) {
    cause_list.find((cause) => {
      if (cause.short_code == user_cause) {
        user_cause_name = cause.name;
      }
    });
  }

  return (
    <div><Dropdown
    ArrowDown="images/Icons/Chevron/large.svg"
    data={causeList}
    isDropup={false}
    setSelected={setSelectedCause}
    dropdownTitle={user_cause_name?.length > 0 || selectedCause?.length > 0 ? ' ' : user_cause_name}
    selected={user_cause_name}
    charityClassName="charity_selected_value"
    dropdownType={"Charity"}  
  />
    {show_charity_active_msg && selectedCause && <div className="charity_message_div"><span className={`x-small charity-message`}>You are now supporting {selectedCause}</span></div>}
  </div>
    // <Dropdown
    //       ArrowDown="/images/Icons/Chevron/large.svg"
    //       data={sizeData}
    //       disabled={disabled}
    //       selected={selectedSize}
    //       setSelected={setSelectedSize}
    //       showStickyDropdown={showStickyDropdown}
    //       isDropdownOpen={isSizeDropdownOpen}
    //       parentHandleToggle={handleDropdownToggle}
    //       isDropup={false}
    //       handleOutsideClick={handleOutsideClick}
    //     />
  )
}